// extracted by mini-css-extract-plugin
export default {"layout":"_481c31de1a df1ba555a6 _357dbb7bd1","h_slide":"_11e8ec94f5","category":"dc69d1c88a _6b61c778d3 e40b2126ed"};